
<div class="border-gray-400 lg:border-l-0  lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r">
  <div class="flex justify-center">
    <div class="block p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 w-full">
      <div class="sm:p-2 md:p-6">
        <div class="flex justify-center" *ngIf="title">
          <div class="max-w-lg text-2xl font-semibold leading-relaxed text-gray-700 dark:text-white mb-3">{{ title }}</div>
        </div>
          <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
